<i class="fal fa-angle-double-right arrows inverted" [ngClass]="{'rotate': !buttonState}"></i>
@if (icon) {
  <i class="{{icon}}"></i>
}
<span #content class="flap-text">
  <ng-content></ng-content>
</span>
<i class="fal fa-angle-double-right rotate arrows" [ngClass]="{'rotate': buttonState}"></i>
